import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CategoryHero from './components/CategoryHero';
import CategoryGrid from './components/CategoryGrid';
import CategoryCTA from './components/CategoryCTA';
import { getCategoryBySlug } from '@/mocks/categories';

const baseUrl = 'http://kiyvx.cn/';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = slug ? getCategoryBySlug(slug) : undefined;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  const categoryName = category?.name || '全部分类';
  const pageTitle = category
    ? `${category.name}漫画 - 高清${category.name}漫画全集免费阅读下拉式`
    : '漫画分类 - 高清漫画全集免费阅读下拉式';
  const pageDesc = category
    ? `178漫画网${category.name}漫画分类：${category.description}。收录${category.comicCount}部${category.name}题材漫画，超清画质下拉式阅读，视觉盛宴尽在178漫画网。`
    : '178漫画网漫画分类导航：治愈、热血、恋爱、悬疑等多种类型，海量高清漫画全集免费阅读下拉式，发现你的下一部心动作品。';

  const categoryJsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: baseUrl },
        {
          '@type': 'ListItem',
          position: 2,
          name: categoryName,
          item: `${baseUrl}/category/${slug || ''}`,
        },
      ],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: pageTitle,
      description: pageDesc,
      url: `${baseUrl}/category/${slug || ''}`,
      isPartOf: { '@id': `${baseUrl}/#website` },
    },
  ];

  return (
    <>
      <SEOHead
        title={pageTitle}
        description={pageDesc}
        keywords={`${categoryName}漫画,高清,漫画全集,免费阅读,下拉式,178漫画网`}
        canonicalUrl={`${baseUrl}/category/${slug || ''}`}
        ogImage={category?.image}
        jsonLd={categoryJsonLd}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <CategoryHero categorySlug={slug} />
          <CategoryGrid activeCategorySlug={slug} />
          <CategoryCTA categorySlug={slug} />
        </main>
        <Footer />
      </div>
    </>
  );
}